import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
 
import { Link } from "react-router-dom";

import * as apiUrl from "../../apiUrl";

function BlogList() {
  const [BlogList, setBlogList] = useState([]);

  useEffect(() => {
    const fetchBlogList = async () => {
      try {
        const response = await fetch(
          apiUrl.apiUrl + `/api/blogs/blog-inner-pages`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const data = await response.json();
        setBlogList(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBlogList();
  }, []);

  const extractFirstSentence = (htmlContent) => {
    const parser = new DOMParser();
    const parsedDocument = parser.parseFromString(htmlContent, "text/html");

    // Get the first paragraph
    const firstParagraph = parsedDocument.querySelector("p");

    if (firstParagraph) {
      let textContent = firstParagraph.textContent.trim();
      const sentences = textContent.match(/[^.!?]+[.!?]/g);

      // Return the first sentence if available
      if (sentences && sentences.length > 1) {
        return sentences[0].trim();
      }
    }

    return "";
  };

  return ( 
      <section className="media-list-sec latest-card-sec">
        <Container fluid>
          <Row className="flex-center text-center mb-3">
            <Col md={12}>
              <div className="home-community-head">
                <h2 className="common-head greyColor" data-aos="fade-up">
                  More For You
                </h2>
              </div>
            </Col>
          </Row>
        </Container>
        <Container fluid>
          <Row className="flex-center">
            {BlogList.map((blog) => (
              <Col md={4} key={blog.id}>
                <div className="media-list-card" data-aos="fade-up">
                  <div className="media-list-img">
                    <img
                      src={apiUrl.apiUrl + "/" + blog.card_image}
                      className="img-fluid"
                      alt={`Apartments for sale in Dubai`}
                    />
                  </div>
                  <div className="media-list-content">
                    <h3 className="media-list-heading blog-list-heading">{blog.blog_title}</h3>
                    <p className="media-list-para blog-list-para">
                      {extractFirstSentence(blog.description)}
                    </p>

                    <div className="media-list-button-div">
                      <Link
                        to={`/blog/${blog.slug}`}
                        className="marquis-roundededge-colored-button"
                      >
                        Read More
                      </Link>
                      <p className="media-list-para goldenColor">
                        Date: {blog.place} {blog.posting_date}
                      </p>
                    </div>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </Container>
      </section> 
  );
}

export default BlogList;
